// Editorial row used by Dashboard "Earlier", Reports list, and the meeting
// pickers. Date in the left gutter, title body, optional score pill, arrow.
//
// The score pill is optional because today's `AnalysisListItem` shape
// doesn't include an overall score. When the list endpoint adds one, just
// pass `score` and the pill renders automatically.

import { Link } from "react-router";
import { ScorePill } from "./ScorePill";

export type EarlierRowProps = {
  to: string;
  date: string; // already-formatted, e.g. "06 May"
  title: string;
  ctx?: string; // secondary text, e.g. one-line readout or call type
  score?: number; // overall score 0-100; renders ScorePill if provided
};

export function EarlierRow({ to, date, title, ctx, score }: EarlierRowProps) {
  return (
    <Link to={to} className="row">
      <span className="when">{date}</span>
      <span className="what">
        <span className="title">{title}</span>
        {ctx ? <span className="ctx">{ctx}</span> : null}
      </span>
      {typeof score === "number" ? <ScorePill score={score} /> : null}
      <span className="arr" aria-hidden="true">→</span>
    </Link>
  );
}
